export default __webpack_public_path__ + "static/media/Icon material-send.7e1bed17.svg";